import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'
import { Address } from '@lukso/controllerapps-sharedlogic-primitives'

const LinkedContractsFactoryAddressPropsSchema = z.object({
  linkedContractsFactoryAddressValue: z.instanceof(Address),
})

type LinkedContractsFactoryAddressProps = z.infer<
  typeof LinkedContractsFactoryAddressPropsSchema
>

export class LinkedContractsFactoryAddress extends ValueObject<LinkedContractsFactoryAddressProps> {
  public getValue(): Address {
    return this.props.linkedContractsFactoryAddressValue
  }

  /**
   * @returns A 0x-prefixed checksum-based hex string of the address.
   */
  public getChecksumValue(): string {
    return this.props.linkedContractsFactoryAddressValue.getChecksumValue()
  }

  public static create(
    props: LinkedContractsFactoryAddressProps
  ): LinkedContractsFactoryAddress {
    const validatedProps = LinkedContractsFactoryAddressPropsSchema.parse(props)
    return new LinkedContractsFactoryAddress(validatedProps)
  }
}
